import { render, staticRenderFns } from "./ActivatedIcon.vue?vue&type=template&id=4d776540&scoped=true&"
import script from "./ActivatedIcon.vue?vue&type=script&lang=js&"
export * from "./ActivatedIcon.vue?vue&type=script&lang=js&"
import style0 from "./ActivatedIcon.vue?vue&type=style&index=0&id=4d776540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d776540",
  null
  
)

export default component.exports